import { Col, Form, Row,  } from 'antd';
import type { FilterConfig, FilterValues } from 'types';
import { useCallback, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import {
  RightOutlined,
} from '@ant-design/icons';
import DataGrid from 'components/theme_components/DataGrid';
import ExportXLS from 'components/theme_components/ExportXLS';
import type { FormInstance } from 'antd/lib/form';
import HeroTitle from 'components/theme_components/HeroTitle';
import { findFinModificationByAnyRefOrStatus } from 'services/fincontract';
import { useNavigate } from 'react-router-dom';
import IPen from 'icons/IPen';
import UpcomingPaymentModal from './Modals/UpcomingPaymentModal';
import ModalSFS from 'components/theme_components/ModalSFS';

export type UpcomingPaymentProps = {
  form: FormInstance;
  color?: string;
  tpauthid: number;
  tpid?: number;
  itemsCompanyHierarchyTree: any[];
  tptype?: string;
  isActive?: boolean;
  onTabActivated?: () => void;
  onNavigateToContract?: (contractNumber: string) => void;
};

const UpcomingPayment = (props: UpcomingPaymentProps) => {
  const {
    form,
    color,
    tpauthid,
    tpid,
    itemsCompanyHierarchyTree,
    tptype,
    isActive,
    onTabActivated,
  } = props;
  const navigate = useNavigate();
  const [filterForm] = Form.useForm();
  const [searchParams, setSearchParams] = useState({});
  const queryClient = useQueryClient();

  const { data, refetch, isFetching } = useQuery(
    ['findFinModificationByAnyRefOrStatus', { tpid: Number(tpid) }],
    () =>
      findFinModificationByAnyRefOrStatus({
      ctreference: '',
      modevent: '',
      modstatus: '',
      modtype: '',
      ctrid:  0,
    }).then(
        (res) => res.list || []
      ),
  );




  const filterConfig: FilterConfig[] = [
    {
      key: 'productFamily',
      label: 'Famille produit',
      type: 'select',
      options: [
        { label: 'Tous', value: '' },
        { label: 'VN', value: 'VN' },
        { label: 'VD', value: 'VD' },
        { label: 'VO', value: 'VO' },
        { label: 'SPR', value: 'SPR' },
      ],
    },
    { key: 'invoiceNumber', label: 'N° facture', type: 'text' },
    { key: 'vin', label: 'VIN', type: 'text' },
    { key: 'contractNumber', label: 'N° contrat', type: 'text' },
    {
      key: 'paymentDate',
      label: 'Date de paiement',
      type: 'date',
      placeholder: 'Date de paiement',
    },
   
    { key: 'amountMin', label: 'Montant', type: 'number' },
     { key: 'amountMax', label: 'Montant', type: 'number' },
  ];



  const handleFilterSearch = useCallback((values: FilterValues) => {
    const formattedValues = {
      ...values,
      paymentDateMin: values.paymentDateMin
        ? values.paymentDateMin.format('YYYY-MM-DD')
        : '',
      paymentDateMax: values.paymentDateMax
        ? values.paymentDateMax.format('YYYY-MM-DD')
        : '',
    };
    setSearchParams(formattedValues);
  }, []);

  const handleFilterReset = useCallback(() => {
    filterForm.resetFields();
    setSearchParams({});
  }, [filterForm]);

  const columns = [
    {
      title: 'N° facture',
      dataIndex: 'sireference', // Using sireference as specified
      key: 'sireference',
      width: 150,
    },
   
    {
      title: 'VIN2',
      dataIndex: 'vin2',
      key: 'vin2',
      width: 150,
      render: (value: string) => value || '',
    },
    {
      title: 'N° contrat',
      dataIndex: 'ctreference', // Using ctreference as specified
      key: 'ctreference',
      width: 200,
    },
    {
      title: 'Famille produit',
      dataIndex: 'tpname', // Using tpname as specified
      key: 'tpname',
      width: 120,
    },
    {
      title: 'Date du paiement',
      dataIndex: 'paydate', // Using paydate as specified
      key: 'paydate',
      width: 150,
      sorter: true,
      render: (value: string) =>
        value ? new Date(value).toLocaleDateString('fr-FR') : '',
    },
    {
      title: 'Montant du paiement (€)',
      dataIndex: 'payamount', // Using payamount as specified
      key: 'payamount',
      width: 180,
      render: (value: number) =>
        value?.toLocaleString('fr-FR', { minimumFractionDigits: 0 }),
    },
      // {
      //     title: '',
      //     key: 'arrow',
      //     width: '80px',
    
      //     render: (record: any) => (
      //       <ModalSFS
      //         className="color-gray"
      //         trigger={({ setVisible }) => (
      //           <IPen
      //             onClick={() => setVisible(true)}
      //             style={{
      //               cursor: 'pointer',
      //             }}
      //           />
      //         )}
      //         title="updaterate"
      //         footer
      //         width={560}
      //       >
      //         <UpcomingPaymentModal
      //           setVisible={() => false}
      //           refetch={() => {
      //             refetch();
      //           } }              />
      //       </ModalSFS>
      //     ),
      //     onHeaderCell: () => ({
      //       style: { paddingLeft: '12px' },
      //     }),
      //   },
  ];

  const colsXLS = [
    'ssinvoice',
    'vin',
    'ctreference',
    'tpname',
    'paydate',
    'payamount',
  ]; 
  return (
    <Form form={form} className="bg-color-gray">
      <div className="bg-color-gray">
        <HeroTitle
          form={filterForm}
          color={color || 'purple'}
          title="UpcomingPayment" 
          display
          showFilter
          filterConfig={ filterConfig}
          onFilterSearch={handleFilterSearch}
          onFilterReset={handleFilterReset}
          className="paymenthistory"
          noTitleOverlay
          itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
        />
      </div>
      <div className="ut-title-page no-after">
        <Row justify="space-between" align="middle" className="mb-4 mt-6">
          <Col></Col>
          <Col span={5} className="d-flex justify-end align-center">
            <ExportXLS
              data={data || []}
              filename="payment-history"
              columns={colsXLS}
            />
          </Col>
        </Row>
        <Row className="w-100 mb-1 d-flex align-center">
          <Col span={24}>
            <Form.Item name="filteredData" initialValue={data}>
              <DataGrid
                columns={columns}
                dataSource={data || []}
                size="large"
                className="custom-data-grid"
                rowKey="id"
                isLoading={isFetching}
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} sur ${total}`,
                }}
                scrollInput={{ x: 1000, y: 550 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default UpcomingPayment;
